document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.rs-related-products [data-slider]:not(.swiper-initialized)');
  carousels.forEach(carousel => {
    const section = carousel.closest('.rs-related-products') || carousel.parentElement;
    new Swiper(carousel, {
      slidesPerView: Number(carousel.getAttribute('data-slides-per-view')) || 1,
      spaceBetween: 16,
      breakpoints: JSON.parse(carousel.getAttribute('data-breakpoints') || '{}'),
      navigation: {
        nextEl: section?.querySelector('.swiper-button-next') || '.swiper-button-next',
        prevEl: section?.querySelector('.swiper-button-prev') || '.swiper-button-prev',
      },
      pagination: {
        el: section?.querySelector('.fraction-indicator') || '.fraction-indicator',
        type: 'fraction',
      },
    });
  });
});
